// extracted by mini-css-extract-plugin
export default {"color":"ElectricRatePrice_color__TLLbn"};